import { useRetry } from '@rpldy/retry-hooks'
import type { UploadOptions } from '@rpldy/uploady'
import { useEffect, useRef } from 'react'

import { uploadManageEvents } from './events'

/**
 * 处理文件上传的 token 刷新和重试
 *
 * 监听 'retry-item' 事件，在 token 刷新成功后自动重试失败的上传
 */
export const useUploadTokenRefresh = () => {
    const retry = useRetry()
    const retryMapRef = useRef(new Map<string, boolean>())

    useEffect(() => {
        const handleRetryItem = (payload: { itemId: string; options?: UploadOptions }) => {
            const { itemId, options } = payload

            // 防止重复重试
            if (retryMapRef.current.get(itemId)) {
                return
            }
            retryMapRef.current.set(itemId, true)

            // 延迟一点再重试，确保 token 已更新
            setTimeout(() => {
                retry(itemId, options)
                retryMapRef.current.delete(itemId)
            }, 100)
        }

        uploadManageEvents.on('retry-item', handleRetryItem)

        return () => {
            uploadManageEvents.off('retry-item', handleRetryItem)
        }
    }, [retry])

    return {
        retry
    }
}
